import {AnyAction} from 'redux'
import {TicketWithFormattedSalePeriod} from '@wix/events-types'
import {CHANGE_EVENT} from '../actions/event'

export const tickets = (state: TicketWithFormattedSalePeriod[] = [], action: AnyAction) => {
  switch (action.type) {
    case CHANGE_EVENT:
      return action.payload.tickets
    default:
      return state
  }
}
